<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>
    <basic-table
      v-if="telDirections"
      :items="telDirections"
      :fields="telDirectionsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedTelDirections"/>
  </div>
</template>

<script>
import editModal from './editModal'
import moment from 'moment'

export default {
  components: {
    editModal
  },
  data () {
    return {
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'updateDate', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'zones', label: this.$i18n.t('Zone'), sortable: true},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix'), sortable: true},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTelDirections: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTelDirections = {
        called_prefix: '',
        called_prefix_regexp: true,
        calling_prefix: '',
        calling_prefix_regexp: true,
        dir_coverage_type: 0,
        dir_id: 0,
        incoming_trunk: '',
        name: '',
        outgoing_trunk: '',
        pbx_id: '',
        skip: false,
        zone_id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditTelephoneDirections', '#btnShow')
    },
    async editItem (item) {
      await this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS', item.dir_id).then(response => {
        this.selectedTelDirections = this.$store.getters['Tariffing/TEL_DIRECTIONS']
      })
      this.$root.$emit('bv::show::modal', 'modalEditTelephoneDirections', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Telephone directions"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TEL_DIRECTIONS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TEL_DIRECTIONS_LIST')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    telDirections () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST']))
      for (let el of copy) {
        el.create_date = moment(Number(el.create_date) * 1000).format('YYYY-MM-DD hh:mm')
        if (el.update_date) {
          el.updateDate = moment(Number(el.update_date) * 1000).format('YYYY-MM-DD hh:mm')
        } else {
          el.updateDate = this.$i18n.t('Not installed')
        }
        for (let elZone of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))) {
          if (el.zone_id === elZone.zone_id) {
            el.zones = elZone.name + ' (' + elZone.zone_id + ')'
            break
          }
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TEL_ZONES')
    this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/telephone/telephoneDirections/main.vue